import React from "react"
import { IError } from "validation"
import FormErrorText, { IFormErrorText } from "components/FormErrorText"
import { useIntl } from "react-intl"

interface IFormErrorProps extends IFormErrorText {
  error?: IError
}

const FormError = ({ error, ...rest }: IFormErrorProps) => {
  const { formatMessage } = useIntl()

  if (!error || typeof error !== "object") return null
  const { message } = error
  const { id, values } = message || {}

  const errorMessage = formatMessage({ id: `error.message.${id}` }, { ...values })

  return <FormErrorText {...rest}>{errorMessage}</FormErrorText>
}

export default FormError
